import { useContext } from 'react';
import { SkeletonContext } from './SkeletonContext';

export default function useSkeletonContext() {
    const context = useContext(SkeletonContext);

    if (!context) {
        throw new Error(
            'useSkeletonContext must be used within a SkeletonContextProvider. Wrap a parent component in <SkeletonContextProvider> to fix this error'
        );
    }

    return context;
}
